import { Component } from '@angular/core';
import { MatDialogRef } from '@iota/iota-ui-components';

@Component({
    standalone: false,
    selector: 'app-employee-document-resubmission-dialog',
    templateUrl: './employee-document-resubmission-dialog.component.html',
    styleUrls: ['./employee-document-resubmission-dialog.component.scss']
})
export class EmployeeDocumentResubmissionDialogComponent {
    reason: string;
    message: string;

    constructor(private dialogRef: MatDialogRef<EmployeeDocumentResubmissionDialogComponent>) {}

    requestResubmission() {
        this.dialogRef.close({ reason: this.reason, message: this.message });
    }
}
